import { Subscription, combineLatest } from 'rxjs';
import { AdnocUsersService } from './../../shared/services/adnoc-users.service';
import { ChangeSearch, DeleteHistory, ResetPage } from './../../state/page-history-state-model';
import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState, Logout, PageHistoryState } from 'src/app/state';
import { LoginService } from 'src/app/core/services';
import { LocalStorage } from 'src/app/core/security/local-storage';
import { Auth, AuthSecurity } from 'src/app/core/security/auth';
import { FiltersService } from 'src/app/shared/services/filters.service';

import { MyMazayaPlusService } from 'src/app/features/my-mazaya-plus/services';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MemberGenderModel } from 'src/app/shared/models/mazaya-plus/card-details-model';
import { email } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})

export class NavigationComponent implements OnInit, OnDestroy {

  @ViewChild('navSub', { read: ElementRef }) public navSubSmallScreen;

  // Search
  searchTextPlaceholder: string = "";
  searchText: string = "";
  genderForm: FormGroup;
  // Modals
  notificationModal: boolean;
  dropDownUserModal: boolean=false;
  dropDownNavModal: boolean;
  selectedDropDown: string;
  mobileNumberError: boolean = false;
  // Profile image
  profilePicture: string = null;
  clientsPhotoChanged: Subscription;

  // Responsive navigation
  timerNavSmall: any;
  activeNav: string;
  isMazayaEligible: boolean = false;
  isPowerEligible: boolean = false;
  isExploreEligible: boolean = false;
  // isMazayaAdmin: boolean = false;
  isMazayaAdmin: string;
  membercardcount: boolean = false;
  powermembercardcount: boolean = false;
  exploremembercardcount: boolean = false;
  // signalR
  assignedOffersCount: number = 0;
  blockedOffersCount: number = 0;
  // phoneNotSpecified: boolean = false;
  // genderNotSpecifiedUser: boolean = false;

  phoneNumber: string = '';
  gender: string = '';

  isModalOpen: boolean = false;
  role: string;

  isLoaded: boolean = false
  private routerSubscription: Subscription;
  private authSubscription: Subscription;
  constructor(
    private router: Router,
    private store$: Store,
    private adnocUserService: AdnocUsersService,
    private loginService: LoginService,
    private _filterService: FiltersService,
    private _mazayaPlusService: MyMazayaPlusService,
    private fb: FormBuilder,

  ) {
    this.genderForm = this.fb.group({
      membersList: this.fb.array([])
    });
    this.router.events.subscribe((event: Event) => {
      this.changeActiveNav(this.router.url.split("/")[1]);
    });


  }

  ngOnInit() {
    console.log("isModalOpen", this.isModalOpen)
    
    // Check if user is authenticated before loading navigation
    // Use combineLatest to wait for both authentication and roles
    this.authSubscription = combineLatest([
      this.store$.select(AuthState.isAuthenticated),
      this.store$.select(AuthState.roles)
    ]).subscribe(([isAuthenticated, roles]) => {
      if (isAuthenticated && roles && roles.length > 0) {
        // User is authenticated, load navigation
        this.role = roles[0];
        this.loadAuth();
        this.initSearch();
        this.initUserProfileImage();
        this.subscribeFor_usersPhotoChanged();
        
        if (this.role == 'Buyer') {
          this.checkMazayaPlus();
        } else {
          this.isLoaded = true;
        }
      } else {
        // User is not authenticated, keep navigation hidden
        this.isLoaded = false;
      }
    });
    
    console.log('Local Storage at ngOnInit:', localStorage.getItem('isMazayaAdmin'));

    // this.getMembersWithoutGender(true)

    //this.checkForLoginPage(this.router.url);
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {

        this.checkForLoginPage(event.urlAfterRedirects);
      }
    });
  }

  loadAuth() {
    this.store$.select(AuthState.roles).subscribe((roles) => {
      if (roles && roles.length > 0) {
        this.role = roles[0];
      }
    });
  }

  subscribeFor_usersPhotoChanged() {
    this.clientsPhotoChanged = this.adnocUserService.clientsPhotoChanged.subscribe(() => {
      this.initUserProfileImage();
    });
  }
  checkForLoginPage(currentUrl: string) {

    if (currentUrl === '/login') {
      this.isModalOpen = false;
    }
  }
  initUserProfileImage() {
    if (!this.store$.selectSnapshot(AuthState.userId)) {
      return;
    }
    this.adnocUserService.getAdnocUsersProfilePicture().subscribe((res) => {
      if (res) {
        this.profilePicture = res.toLocaleUpperCase(); // to upper and to string
      } else {
        this.profilePicture = null;
      }
    });
  }

  userProfileImageState($event) {
    // if ($event.reason == "loading-failed") {
    //   setTimeout(() => {
    //     this.profilePicture = "111-111-111-111";
    //     this.initUserProfileImage();
    //   }, 500);
    // }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.clientsPhotoChanged) {
      this.clientsPhotoChanged.unsubscribe();
    }
  }

  initSearch() {
    this.store$.select(PageHistoryState).subscribe((res) => {
      this.searchTextPlaceholder = res.searchPlaceholder;
      this.searchText = res.query.filter.keyword;
    });
  }

  changeActiveNav(activeNav) {

    this.activeNav = activeNav;
  }

  routeToAllSuggestion() {
    this.router.navigateByUrl('suggestions/all')
  }
  search() {
    this.store$.dispatch(new ChangeSearch(this.searchText));
  }

  searchReset() {
    this.searchText = "";
    this.search();
  }

  logOut() {
    this.loginService.logout().subscribe(() => {
      localStorage.clear();
      sessionStorage.clear();
      this.dropDownUserModal = false;
      this.store$.dispatch(new DeleteHistory());
      this.store$.dispatch(new ResetPage());
      this.store$.dispatch(new Logout());
      this.genderForm.reset();
      this.membersList.clear();
    })

  }

  reset() {
    this.store$.dispatch(new ResetPage());
  }

  // Navigations (responsive)
  moveToRightNavSub(): void {
    this.timerNavSmall = setInterval(() => {
      this.navSubSmallScreen.nativeElement.scrollLeft += 15;
    }, 50);
  }

  moveToLeftNavSub(): void {
    this.timerNavSmall = setInterval(() => {
      this.navSubSmallScreen.nativeElement.scrollLeft -= 15;
    }, 50);
  }

  stopMoveNavSub(): void {
    clearInterval(this.timerNavSmall);
  }
  checkMazayaPlus() {
    this.store$.select(AuthState.token).subscribe((token) => {
      if (token) {
        this._filterService.getUserInfo().subscribe((response) => {
          this.isLoaded=true
          const res = response.data
          this.isMazayaAdmin = res.mazayauserdetails.isAdmin;
          this.isMazayaEligible = res.isMazayaEligible;
          this.isExploreEligible = res.hasExplore;
          this.isPowerEligible = res.hasPower;
          if (this.isMazayaAdmin) {

            this.getMembersWithoutGender(true)
          } else {

            this.getMembersWithoutGender(false)
          }

          // if (this.router.url === '/login') {
          //   this.isModalOpen = false;
          // } else {
          //   this.isModalOpen = res.phoneNotSpecified || res.genderNotSpecifiedUser;
          // }

          if (res.mazayauserdetails.membercardcount != 0) {
            this.membercardcount = true;
          } else
            this.membercardcount = false

          if (res.powerexploredetails.powermembercardcount != 0) {

            this.powermembercardcount = true;
          } else
            this.powermembercardcount = false

          if (res.powerexploredetails.exploremembercardcount != 0) {
            this.exploremembercardcount = true;
          }
          else
            this.exploremembercardcount = false;
        });
      }
    });
  }

  getMembersWithoutGender(isAdmin: boolean) {
    this.store$.select(AuthState.token).subscribe((token) => {
      if (token) {


        this._mazayaPlusService.getMembersWithoutGender(isAdmin).subscribe((res) => {
          if (res.data.length !== 0) {
            this.isModalOpen = true
            res.data.forEach((element: MemberGenderModel, index) => {
              if (index == 0) {
                this.genderForm.reset();
                this.membersList.clear();
              }
              let PhoneNumber = element.PhoneNumber!=null && element.PhoneNumber.startsWith('971')
                ? element.PhoneNumber.substring(3)
                : element.PhoneNumber;

              console.log("!!!!!!!!!!!!!!!", element)
              this.membersList.push(this.createMemberFormGroup({
                ...element,
                PhoneNumber
              }));
              console.log("!!!!!!!!!!!!!!!", element)
              // this.membersList.push(this.createMemberFormGroup(element));
            });
          } else {

            // this.isModalOpen = false;  
          }
        });
      }
    });
  }


  get membersList() {
    return this.genderForm.get('membersList') as FormArray;
  }
  createMemberFormGroup(item: MemberGenderModel) {
    return this.fb.group({
      name: [item.name],
      ecarddetailsId: [item.Email],
      gender: [item.Gender, Validators.required],
      phoneNumber: [item.PhoneNumber, [Validators.required]],
      isCardUser: [item.isCardUser]
    });
  }
  // updateMembersGender() {


  //   if (this.genderForm.valid) {
  //     console.log(this.genderForm.value);
  //     const list = this.genderForm.value
  //     this._mazayaPlusService.updateGender(list.membersList)
  //       .subscribe((res) => {
  //         this.modalGenderUpdate=false;
  //       })
  //   } else {
  //     this.genderForm.markAllAsTouched(); // Mark all fields as touched to trigger validation messages
  //   }


  updateMembersGender() {
    if (this.genderForm.valid) {
      const transformedList = this.membersList.value.map((member: any) => ({
        ...member,
        PhoneNumber: '971' + member.PhoneNumber
      }));

      console.log(transformedList);

      this._mazayaPlusService.updateGender(transformedList).subscribe(
        (res) => {
          this.isModalOpen = false;
        },
        (err) => {
          console.error(err);
        }
      );
    } else {
      this.genderForm.markAllAsTouched();
    }
  }


}
